<template xmlns:v-pikaday="http://www.w3.org/1999/xhtml">
  <div class="header-wrapper animate fadeIn">

    <div class="container upload-slip">
      <h1 class="header-title">แจ้งโอนเงิน #{{this.orderId}}</h1>
      <div class="block-primary block shadow radius mb-15">
        <form @submit.prevent="submit" class="form" novalidate>
          <div class="form__item">
            <label class="form__label" for="orderid">เลขที่การบริจาค</label>
            <input class="form__input" type="text" name="orderid" id="orderid" disabled v-model="info.orderId" required :class="{ 'form__input--error': $v.isError('orderId') }" />
            <div class="alert alert--error" v-show="$v.$errors.orderId.empty">กรุณากรอกเลขที่บริจาค</div>
          </div>

          <div class="form__item">
            <label for="bank" class="form__label">โอนจากธนาคาร</label>
            <select id="bank" class="form__input text-left" v-model="info.bankCode" required :class="{ 'form__input--error': $v.isError('bankCode') }">
              <option v-for="bank in $utils.banks" :key="bank.code" :value="bank.code">{{ bank.name_th }} ({{ bank.name_en}})</option>
            </select>
            <div class="alert alert--error mt-15" v-show="$v.$errors.bankCode.empty">กรุณาระบุธนาคารที่โอน</div>
          </div>

          <div class="form__item">
            <label class="form__label" for="amount">จำนวนเงินที่โอน (บาท)</label>
            <input class="form__input" id="amount" placeholder="123.45" type="text" v-model="info.amount" required :class="{ 'form__input--error': $v.isError('amount') }">
            <div class="alert alert--error" v-show="$v.$errors.amount.empty">กรุณาระบุจำนวนเงินที่โอนมาจริงๆ (ใส่ทศนิยมด้วยถ้ามี) เพื่อง่ายต่อการตรวจสอบ</div>
            <div class="alert alert--error" v-show="$v.$errors.amount.invalid">กรุณาระบุจำนวนเงินให้ถูกต้อง เป็นตัวเลขและจุดทศนิยม 2 หลักเท่านั้น</div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-3">
              <div class="form__item">
                <label class="form__label" for="date">วันที่โอน</label>
                <input class="form__input" id="date" placeholder="01/12/2018" type="text" readonly v-pikaday:selected="setDate" required :class="{ 'form__input--error': $v.isError('date') }">
                <div class="alert alert--error" v-show="$v.$errors.date.empty">กรุณาเลือกวันที่โอน</div>
              </div>
            </div>
            <div class="col-sm-12 col-md-3">
              <div class="form__item">
                <label class="form__label">เวลาที่โอน ( เช่น 14:50 )</label>
                <select class="form__input form__input--sm text-left" v-model="info.hour" required :class="{ 'form__input--error': $v.isError('hour') }">
                  <option v-for="i in $utils.range(0, 23)" :key="i" :value="pad(i)">{{ pad(i) }}</option>
                </select> :
                <select class="form__input form__input--sm text-left" v-model="info.minute" required :class="{ 'form__input--error': $v.isError('minute') }">
                  <option v-for="i in $utils.range(0, 59)" :key="i" :value="pad(i)">{{ pad(i) }}</option>
                </select>
                <div class="alert alert--error mt-15" v-show="$v.$errors.hour.empty || $v.$errors.minute.empty">กรุณาระบุเวลาที่โอน</div>
                <div class="alert alert--error mt-15" v-show="$v.$errors.hour.invalid || $v.$errors.minute.invalid">กรุณาระบุเวลาที่โอนให้ถูกต้อง</div>
              </div>
            </div>
          </div>

          <upload-picker :order-id="info.orderId" @uploaded="imageUploaded"></upload-picker>
          <div class="alert alert--error" v-show="$v.$errors.imageUrl.empty">โปรด upload รูปภาพก่อน</div>

          <div class="form__item">
            <label class="form__label" for="message">ข้อมูลเพิ่มเติม</label>
            <textarea class="form__input" id="message" v-model="info.message"></textarea>
          </div>

            <button class="btn btn--purple btn-md">ส่งหลักฐานการโอนเงิน</button>
            <p>เมื่อเจ้าหน้าที่ตรวจสอบการโอนเงินแล้ว ผู้บริจาคจะได้รับอีเมลยืนยันอีกครั้ง จึงจะถือว่าการบริจาคเสร็จสมบูรณ์  </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import UploadPicker from './UploadPicker'

export default {
  components: { UploadPicker },
  name: 'UploadSlip',
  data () {
    return {
      showModal: false,
      submitting: false,
      info: {
        orderId: '',
        bankCode: '',
        amount: null,
        date: '',
        hour: '',
        minute: '',
        message: '',
        imageUrl: ''
      },
      $v: null
    }
  },
  created () {
    this.$v = this.$validator.init(this.info, {
      orderId: { checkEmpty: true },
      date: { checkEmpty: true },
      bankCode: { checkEmpty: true },
      amount: { checkEmpty: true, checkAmount: true },
      hour: { checkEmpty: true, checkHour: true },
      minute: { checkEmpty: true, checkMinute: true },
      imageUrl: { checkEmpty: true }
    })
  },
  computed: {
    orderId () {
      return this.$route.query.orderId || this.$route.params.orderId
    },
    canSubmit () {
      return !this.submitting && this.info.imageUrl
    }
  },
  mounted () {
    if (!this.orderId) {
      this.$router.push('/')
    } else {
      this.$http.get(`invoices/${this.orderId}`)
        .then(resp => {
          if (resp.body.status === 3) {
            this.$modal.show({
              title: 'หมดเวลาโอนเงินแล้ว',
              text: 'ขอแจ้งให้ทราบว่ารายการบริจาคนี้ได้เกินกำหนดเวลาชำระเงินแล้ว หากมีข้อสงสัยกรุณาติดต่อ ' + Vue.config.WEBSITE_EMAIL
            })
            this.$router.push('/orders/' + this.orderId)
          } else {
            this.$set(this.info, 'orderId', this.orderId)
            this.$set(this.info, 'email', resp.body.email)
            this.$set(this.info, 'fullname', resp.body.fullname)
          }
        })
        .catch(err => {
          console.log(err)
          this.$utils.showCommonError(() => {
            this.$router.push('/orders/' + this.orderId)
          })
        })
    }
  },
  methods: {
    imageUploaded (url) {
      this.info.imageUrl = url
    },
    setDate (value) {
      this.info.date = value
    },
    pad (value) {
      return `${value}`.replace(/^(\d)$/, '0$1')
    },
    submit (evt) {
      if (this.submitting) {
        return
      }

      if (!this.$v.validate()) {
        this.$forceUpdate()
        this.$utils.scrollToFirstErrors()
        return
      }

      this.submitting = true
      this.$modal.show({
        title: 'โปรดรอสักครู่',
        text: 'กำลังส่งข้อมูล...',
        okButton: false
      })

      if (this.info.imageUrl) {
        let dateStr = this.info.date.replace(/^(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')
        dateStr += `T${this.info.hour}:${this.info.minute}:00+0700`
        const timestamp = this.$utils.parseDate(dateStr)
        const model = {
          'client_id': this.$store.state.clientId,
          'image_url': this.info.imageUrl,
          'order_id': this.info.orderId,
          'bank_code': this.info.bankCode,
          'amount': parseFloat(this.info.amount.replace(/,/g, ''), 10),
          'transfered': timestamp,
          'name': this.info.fullname,
          'email': this.info.email,
          'message': this.info.message
        }

        if (!model.amount) {
          this.$modal.show({
            title: 'ผิดพลาด',
            text: 'จำนวนไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง'
          })
          this.submitting = false
          return
        }

        const maxRetry = 3
        const doPost = (retryCount) => {
          if (retryCount >= maxRetry) {
            this.submitting = false
            this.$utils.showCommonError()
            return
          }

          retryCount++
          this.$http.post('payments/transfer', model)
            .then(resp => {
              this.submitting = false
              this.$modal.show({
                title: 'ได้รับเอกสารแล้ว',
                text: 'รอยืนยันการชำระเงิน หลังจากผู้ตรวจสอบอนุมัติภายใน 48 ชั่วโมง',
                ok: () => {
                  this.$router.push('/orders/' + this.orderId)
                }
              })
            })
            .catch(err => {
              console.error(err)
              if (err.status === 400) {
                this.submitting = false
                this.$modal.show({
                  title: 'ผิดพลาด',
                  text: 'ไม่สามารถส่งข้อมูลได้ เป็นไปได้ว่าคำสั่งนี้จะ075-2-32728-8หมดเวลาโอนเงินแล้ว กรุณาตรวจสอบอีกครั้ง หากมีข้อสงสัย กรุณาติดต่อ ' + Vue.config.WEBSITE_EMAIL
                })
              } else {
                setTimeout(() => {
                  doPost(retryCount)
                }, 1000)
              }
            })
        }

        doPost(0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// UploadSlip.vue?3ec6ee6c